import { NgIf, NgStyle } from "@angular/common";
import { ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'isg-tri-state-checkbox',
  templateUrl: './tri-state-check-box.component.html',
  styleUrls: ['./tri-state-check-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TriStateCheckBoxComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [NgStyle, NgIf, FormsModule]
})
/*
    Support component for using the same checkbox graphic as used in grids
    Can toggle tri state on or off along with custom text labels 
*/
export class TriStateCheckBoxComponent implements ControlValueAccessor, OnInit {

  // ------------- Properties ---------------------------------------------------

  public checked?: boolean | null = false;

  @Input() public nullable: boolean = true;
  @Input() public textTrue: string = "Active";
  @Input() public textFalse: string = "Inactive";
  @Input() public textNotSpecified: string = "";
  @Input() public isDisabled: boolean = false;
  @Input() public widthForced: number | null = null;

  // ------------- Constructor ---------------------------------------------------

  constructor(protected cdr: ChangeDetectorRef) { }

  ngOnInit() { }

  // ------------- Events ---------------------------------------------------

  onChange: any = () => { };

  onTouch: any = () => { };

  onModelChange(e?: boolean) {

    if (this.checked == null)
      this.checked = true;
    else if (this.checked == true)
      this.checked = false;
    else if (this.checked == false && this.nullable == false)
      this.checked = true;
    else if (this.checked == false)
      this.checked = null;

    this.onChange(this.checked);

    this.cdr.detectChanges();
  }

  // ------------- Support ---------------------------------------------------

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  getWidth(): string {
    if (this.widthForced && this.widthForced > 0)
      return this.widthForced.toString() + "rem";

    return "auto";
  }
}
